import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 2,
	viewBox: "0 0 14 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 2V0H14V2H0Z" })
});
export { SvgMinus as ReactComponent };
